declare var self: ServiceWorkerGlobalScope;
export {};

interface ExtendableEvent extends Event {
  waitUntil(fn: Promise<any>): void;
}

interface ActivateEvent extends ExtendableEvent {}

export const activate_listener = (event: ActivateEvent) => {
  event.waitUntil(self.clients.claim());
};
